pageLoad('critiques_new', 'critiques_edit', 'critiques_create', 'critiques_update', () => {
  $('.b-rate').rateable();
});
